import VDLInstance from '@/modules/VDL/api/instances/VDLInstance';

import type { AxiosInstance } from 'axios';

import type { IYear } from '@VDL/api/types/IYear';
import type { IGetLevel0Params } from '@VDL/api/types/IGetLevel0Params';
import type {
  ILevel0Data,
  IToSaveLevel0Data
} from '@VDL/api/types/ILevel0Data';
import type { IVDLButton } from '@VDL/api/types/IVDLButton';
import type { IVDLAgreement } from '@VDL/api/types/IVDLAgreement';

export const getYears = (instance: AxiosInstance = VDLInstance) =>
  instance.get<IYear[]>('main/get-years');

export const getLevel0Data = (
  { year }: IGetLevel0Params,
  instance: AxiosInstance = VDLInstance
) => instance.get<ILevel0Data>(`main/lvl0?year=${year}`);

export const getVDLButtons = (
  level0Code: string | undefined,
  instance: AxiosInstance = VDLInstance
) =>
  instance.get<IVDLButton[]>(
    level0Code ? `buttons/0/${level0Code}` : '/buttons/'
  );

export const getAgreementData = (instance: AxiosInstance = VDLInstance) =>
  instance.get<IVDLAgreement[]>('main/sogl');

export const getPassportIframe = (
  level0Code: string,
  data?: Record<string, unknown>,
  instance: AxiosInstance = VDLInstance
) => instance.get<string>(`main/view/${level0Code}/passport`, { data });

export const putSubmitPassport = (
  level0Code: string,
  instance: AxiosInstance = VDLInstance
) => instance.put(`sogl/${level0Code}/SoglProject`);

export const putCancelAgreement = (
  level0Code: string,
  instance: AxiosInstance = VDLInstance
) => instance.put(`sogl/${level0Code}/cancelSogl`);

export const putLevel0Data = (
  instance: AxiosInstance = VDLInstance,
  data: IToSaveLevel0Data
) => instance.put(`main/top`, data);

export const getButtonLog = (
  buttonCode: string,
  instance: AxiosInstance = VDLInstance
) => instance.get(`buttons/log/${buttonCode}`);
